<router-outlet *ngIf="variantReady()"></router-outlet>
<app-loader *ngIf="!variantReady()" [fullscreen]="true" [backdrop]="false" [background]="'white'"></app-loader>
